/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ITreeItemLookupScope extends ng.IScope {
        model: models.TreeItemLookupModel;
        lookupEntries: Wars.Domain.Model.TreeItemLookup[];
        processConfigId: string;
        includeTreeSections: string;
        isReadonly: boolean;
        }

    export class TreeItemLookup implements IDirective {
        public link($scope: ITreeItemLookupScope, element: JQuery, attrs: ng.IAttributes, controller: TreeItemLookupController) { }
        public templateUrl = "./app/views/directives/treeItemLookup.html";
        public restrict: string = "E";
        public controller = ["$scope", "treeItemLookupService", "treeService", TreeItemLookupController];
        public controllerAs = "controller";
        public scope: any = {
            lookupEntries: "=",
            processConfigId: "=",
            includeTreeSections: "@",
            isReadonly: "="
        };
    }

    export class TreeItemLookupController implements IController {

        constructor(
            private $scope: ITreeItemLookupScope,
            treeItemLookupService: services.TreeItemLookupService,
            treeService: services.TreeService)
        {

            this.$scope.model = new models.TreeItemLookupModel(
                treeItemLookupService,
                treeService,
                this.$scope.lookupEntries,
                this.$scope.processConfigId,
                this.$scope.includeTreeSections === undefined ? "" : this.$scope.includeTreeSections, 
                this.$scope.isReadonly);
        }
    }
}

warsApp.registerDirective("TreeItemLookup", []);